import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ResellersListHeader} from './components/header/ResellersListHeader'
import {ResellersTable} from './table/ResellersTable'
import {ResellerEditModal} from './reseller-edit-modal/ResellerEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const ResellersList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ResellersListHeader />
        <ResellersTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <ResellerEditModal />}
    </>
  )
}

const ResellersListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ResellersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ResellersListWrapper}
